const actions = {
  FINANCE_DASHBOARD_BEGIN: "FINANCE_DASHBOARD_BEGIN",
  FINANCE_DASHBOARD_SUCCESS: "FINANCE_DASHBOARD_SUCCESS",
  FINANCE_DASHBOARD_ERR: "FINANCE_DASHBOARD_ERR",

  FINANCE_HISTORY_BEGIN: "FINANCE_HISTORY_BEGIN",
  FINANCE_HISTORY_SUCCESS: "FINANCE_HISTORY_SUCCESS",
  FINANCE_HISTORY_ERR: "FINANCE_HISTORY_ERR",
  FINANCE_HISTORY_RESET: "FINANCE_HISTORY_RESET",

  FINANCE_DETAILS_BEGIN: "FINANCE_DETAILS_BEGIN",
  FINANCE_DETAILS_SUCCESS: "FINANCE_DETAILS_SUCCESS",
  FINANCE_DETAILS_ERR: "FINANCE_DETAILS_ERR",
  FINANCE_DETAILS_RESET: "FINANCE_DETAILS_RESET",

  FINANCE_UPDATE_APPROVAL_STATUS_BEGIN: "FINANCE_UPDATE_APPROVAL_STATUS_BEGIN",
  FINANCE_UPDATE_APPROVAL_STATUS_SUCCESS: "FINANCE_UPDATE_APPROVAL_STATUS_SUCCESS",
  FINANCE_UPDATE_APPROVAL_STATUS_ERR: "FINANCE_UPDATE_APPROVAL_STATUS_ERR",
  FINANCE_UPDATE_APPROVAL_STATUS_RESET: "FINANCE_UPDATE_APPROVAL_STATUS_RESET",

  getFinanceDashboardBegin: () => ({
    type: actions.FINANCE_DASHBOARD_BEGIN,
  }),

  getFinanceDashboardSuccess: (data) => ({
    type: actions.FINANCE_DASHBOARD_SUCCESS,
    data,
  }),

  getFinanceDashboardErr: (err) => ({
    type: actions.FINANCE_DASHBOARD_ERR,
    err,
  }),

  getFinanceHistoryBegin: () => ({
    type: actions.FINANCE_HISTORY_BEGIN,
  }),

  getFinanceHistorySuccess: (data) => ({
    type: actions.FINANCE_HISTORY_SUCCESS,
    data,
  }),

  getFinanceHistoryErr: (err) => ({
    type: actions.FINANCE_HISTORY_ERR,
    err,
  }),

  getFinanceHistoryReset: () => ({
    type: actions.FINANCE_HISTORY_RESET,
  }),

  getFinanceDetailsBegin: () => ({
    type: actions.FINANCE_DETAILS_BEGIN,
  }),

  getFinanceDetailsSuccess: (data) => ({
    type: actions.FINANCE_DETAILS_SUCCESS,
    data,
  }),

  getFinanceDetailsErr: (err) => ({
    type: actions.FINANCE_DETAILS_ERR,
    err,
  }),

  getFinanceDetailsReset: () => ({
    type: actions.FINANCE_DETAILS_RESET,
  }),

  updateFinanceApprovalStatusBegin: () => ({
    type: actions.FINANCE_UPDATE_APPROVAL_STATUS_BEGIN,
  }),

  updateFinanceApprovalStatusSuccess: (data) => ({
    type: actions.FINANCE_UPDATE_APPROVAL_STATUS_SUCCESS,
    data,
  }),

  updateFinanceApprovalStatusErr: (err) => ({
    type: actions.FINANCE_UPDATE_APPROVAL_STATUS_ERR,
    err,
  }),

  updateFinanceApprovalStatusReset: () => ({
    type: actions.FINANCE_UPDATE_APPROVAL_STATUS_RESET,
  }),
};

export default actions;
